import { render, staticRenderFns } from "./CompanyInvite.vue?vue&type=template&id=5b54b945&"
import script from "./CompanyInvite.vue?vue&type=script&lang=js&"
export * from "./CompanyInvite.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInvite.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports